import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Grid2, IconButton, List, ListItem, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { flexCenter, imageContainer, primaryButton } from "../../styles/commonStyles";

const ImageList = ({ images, onImagesChange }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [newImage, setNewImage] = useState("");

  const isValidImageUrl = (url) => /\.(jpeg|jpg|gif|png|webp)$/i.test(url);

  const handleAddImage = useCallback(() => {
    if (newImage.trim() && isValidImageUrl(newImage)) {
      onImagesChange([...images, newImage.trim()]);
      setNewImage("");
    }
  }, [newImage, images, onImagesChange]);

  const handleRemoveImage = useCallback(
    (index) => {
      onImagesChange(images.filter((_, i) => i !== index));
    },
    [images, onImagesChange],
  );

  const filteredImages = images.filter((image) => image !== "Placeholder.webp");
  const hasError = Boolean(newImage && !isValidImageUrl(newImage));

  return (
    <div>
      <Grid2 container spacing={2} alignItems="center">
        <Grid2 xs={isMobile ? 10 : 11.5}>
          <TextField
            label={t("image.newUrlTitle")}
            value={newImage}
            onChange={(e) => setNewImage(e.target.value)}
            fullWidth
            margin="normal"
            error={hasError}
            helperText={hasError ? t("image.invalidUrl") : ""}
          />
        </Grid2>
        <Grid2 xs={isMobile ? 2 : 0.5}>
          <IconButton aria-label={t("image.addTitle")} variant="contained" sx={primaryButton(theme)} onClick={handleAddImage} disabled={!newImage.trim() || !isValidImageUrl(newImage)}>
            <AddIcon />
          </IconButton>
        </Grid2>
      </Grid2>
      <List>
        {filteredImages.map((image, index) => (
          <ListItem key={index} sx={{ p: 0, m: 0 }}>
            <Grid2 container spacing={2} alignItems="center">
              <Grid2 xs={isMobile ? 12 : 11.5}>
                <Box component="img" src={image} alt={`Uploaded image ${index + 1}`} sx={imageContainer(theme, isMobile)} />
                <Typography variant="body2" sx={{ wordWrap: "break-word" }}>
                  {image}
                </Typography>
              </Grid2>
              <Grid2 xs={isMobile ? 12 : 0.5} sx={flexCenter}>
                <IconButton onClick={() => handleRemoveImage(index)} edge="end" aria-label={t("image.removeTitle")}>
                  <DeleteIcon sx={{ color: theme.palette.error.main }} />
                </IconButton>
              </Grid2>
            </Grid2>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default ImageList;
